import { render, staticRenderFns } from "./IdentityUserInfoComponent.vue?vue&type=template&id=617697fe"
import script from "./IdentityUserInfoComponent.vue?vue&type=script&lang=js"
export * from "./IdentityUserInfoComponent.vue?vue&type=script&lang=js"
import style0 from "./IdentityUserInfoComponent.vue?vue&type=style&index=0&id=617697fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports